import mutations from './mutations'
import actions from './action'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    user: {},
    userInfoReady: 0,
    toLoginAsAdmin: 0,
    permission: false // 默认没有权限
  },
  getters,
  actions,
  mutations,
  modules: {}
}
